export type StatusTone = 'draft' | 'pending' | 'approved' | 'declined' | 'void' | 'paid' | 'danger';

const STATUS_TONE_DOT_CLASSES: Record<StatusTone, string> = {
  draft: 'bg-muted-foreground',
  pending: 'bg-warning',
  approved: 'bg-success',
  declined: 'bg-muted-foreground',
  void: 'bg-muted-foreground',
  paid: 'bg-success',
  danger: 'bg-destructive',
};

/** The dot a `StatusBadge` of this tone shows. */
export function statusToneDotClass(tone: StatusTone): string {
  return STATUS_TONE_DOT_CLASSES[tone];
}

export function expenseStatusTone(status: string): StatusTone {
  if (status === 'DRAFT') return 'draft';
  if (status === 'PENDING') return 'pending';
  if (status === 'APPROVED') return 'approved';
  if (status === 'REJECTED') return 'declined';
  if (status === 'VOIDED') return 'void';
  if (status === 'REIMBURSED') return 'paid';
  return 'draft';
}

export function reimbursementStatusTone(status: string): StatusTone {
  if (status === 'PENDING') return 'pending';
  if (status === 'APPROVED') return 'approved';
  if (status === 'PAID') return 'paid';
  return 'draft';
}

export function changeOrderStatusTone(status: string): StatusTone {
  if (status === 'DRAFT') return 'draft';
  if (status === 'PENDING_APPROVAL') return 'pending';
  if (status === 'APPROVED' || status === 'APPLIED') return 'approved';
  if (status === 'REJECTED' || status === 'DECLINED') return 'declined';
  if (status === 'VOIDED' || status === 'VOID') return 'void';
  return 'draft';
}

export function invoiceStatusTone(status: string): StatusTone {
  if (status === 'draft') return 'draft';
  if (status === 'overdue') return 'danger';
  if (status === 'clearing') return 'pending';
  if (status === 'open' || status === 'sent' || status === 'viewed') return 'pending';
  // A list filter, not a badge: it returns the invoices whose badge reads Open.
  if (status === 'unpaid') return 'pending';
  if (status === 'partial') return 'pending';
  if (status === 'paid') return 'paid';
  if (status === 'void' || status === 'refunded' || status === 'written_off') return 'void';
  return 'draft';
}
